// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	AvailableSoonGrid: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "AvailableSoonGrid" */
				'./index'
			),
	} ),
};
